import React from "react";
import Myrow from "./Myrow";
import "./Myorder.css";


const MyOrder = ({ biddatafast }) => {
  return (
    <>
      <table className="table-everyone-order">
        <tr className="table-everyone-order-heading">
          <td className="text-align-tb">Period</td>
          <td className="my-avtor2">Select</td>
          <td className="text-align-tb">Point</td>
          <td className="my-avtor">Result</td>
          <td className="text-align-tb">Amount</td>
        </tr>
        {biddatafast &&
          biddatafast.map((item) => {
            return (
              <>
                <Myrow
                  period={item.period}
                  bgcolor={item.result_color}
                  numresult={item.number_result}
                  totalamount={item.total_amount}
                  selected={item.bid}
                  amount={item.amount}
                />
              </>
            );
          })}
      </table>
    </>
  );
};

export default MyOrder;
